// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import annotationInfoIcon from "@/assets/icons/annotation-info.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type AnnotationInfoIconProps = Omit<IconProps, "name">;

export function AnnotationInfoIcon(props: AnnotationInfoIconProps): React.ReactNode {
  return <Icon name={annotationInfoIcon} {...props} />;
}
